import { MovementReconciliationActions } from '../bancos/MovementReconciliationActions';
import { useState } from "react"
import { Pagination } from "@mui/material"
import { Link } from "react-router-dom"
import moment from "moment"
import NumberFormat from "react-number-format"
import { PaymentsModal } from "../payments/PaymentsModal"

export const TableList = ({ filters, setFilters, dataList }) => {

    const [page, setPage] = useState(1)
    const [openModalPagos, setOpenModalPagos] = useState(false)
    const [detailPago, setDetailPago] = useState({})

    const handleChange = (event, value) => {
        console.log(value)

        setPage(value)
        const newFilters = {
            ...filters,
            page: value
        }

        setFilters(newFilters)
    }

    const handleOpenModal = (item) => {
        console.log('--current pago--', item)
        setDetailPago(item)
        setOpenModalPagos(true)
    }

    return (
        <div className='p-table'>

            {openModalPagos &&
                <PaymentsModal
                    initialPay={detailPago}
                    title={'Pago emitido'}
                    openModal={openModalPagos}
                    setModal={setOpenModalPagos}
                    dataCompra={{}}
                    checkInitialData={{}}
                    initGetAllPayByGasto={null}
                />
            }

            <div className="row">
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={10}
                        page={page}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th scope="col">Fecha pago</th>
                            <th scope="col" className="text-start">Origen</th>
                            <th scope="col" className="text-start">Proveedor</th>
                            <th scope="col" className='text-center'>Tipo</th>
                            <th scope="col">Cuenta</th>
                            <th scope="col">Nro. Operación</th>
                            <th scope="col" className='text-end'>Total</th>
                            <th>Conciliación</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataList?.length > 0 && dataList?.map(item => (
                            <tr className='text-center p-tr-body-global' key={item.id}>
                                <td>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        <span>{moment(item.fecha_pago).format('DD-MM-YYYY')}</span>
                                    </Link>
                                </td>
                                <td className="text-start">
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        {item.origen || '---'}
                                    </Link>
                                </td>
                                <td className='text-start'>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        {item.proveedor || '---'}
                                    </Link>
                                </td>
                                <td className='text-center'>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        {item.tipo_pago_nombre || '--'}
                                    </Link>
                                </td>
                                <td className='text-center'>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        {item.nombre_cta_bancaria || '--'}
                                    </Link>
                                </td>
                                <td>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        {item.nro_operacion || '--'}
                                    </Link>
                                </td>
                                <td className='text-end'>
                                    <Link
                                        className='LinkTable'
                                        to='#'
                                        onClick={() => handleOpenModal(item)}
                                    >
                                        <NumberFormat
                                            value={item.total_pago ? parseFloat(item.total_pago) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                            decimalScale={2}
                                        />
                                    </Link>
                                </td>
                                <td><MovementReconciliationActions movement={item} type="egreso" onChanged={() => setFilters({...filters})}/></td>
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}